import {
  CHANGE_TABS,
  EDIT_PREFERENCES_SETTINGS,
  EDIT_PREFERENCES_SETTINGS_ERROR,
  EDIT_PREFERENCES_SETTINGS_SUCCESS,
  EDIT_PROVIDER_PASSWORD,
  EDIT_PROVIDER_PASSWORD_ERROR,
  EDIT_PROVIDER_PROFILE_IMAGE,
  EDIT_PROVIDER_PROFILE_INFO,
  GET_SERVICE_TYPES,
  SET_ERROR,
  SET_TABS,
} from '../accountSettings/AccountSettingsConstants'

export const accountSettingsReducerBlackList = [
  GET_SERVICE_TYPES,
  EDIT_PROVIDER_PROFILE_INFO,
  EDIT_PROVIDER_PROFILE_IMAGE,
  EDIT_PROVIDER_PASSWORD,
  EDIT_PREFERENCES_SETTINGS,
  CHANGE_TABS,
  SET_TABS,
  EDIT_PREFERENCES_SETTINGS,
  EDIT_PREFERENCES_SETTINGS_SUCCESS,
  EDIT_PREFERENCES_SETTINGS_ERROR,
  SET_ERROR,
  EDIT_PROVIDER_PASSWORD_ERROR,
]
